/** @format */

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lottie from "react-lottie";
import styled, { keyframes } from "styled-components";
import { QUERIES } from "../../constants";
import * as animationDataA from "./menu-close-lottie.json";

const LOTTIE_DATA = {
  isStopped: true,
  isPaused: false,
  speed: 4,
  direction: 1,
  isLike: false,
};

export default function ActionMenu({ mouseEnter, mouseLeave }) {
  const [lottieData, setLottieData] = useState(LOTTIE_DATA);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const defaultOptions = {
    animationData: animationDataA,
    loop: false,
    autoplay: false,
  };

  function handleDrawerOpen() {
    setIsDrawerOpen(!isDrawerOpen);
    if (lottieData.isStopped === false) {
      setLottieData({
        ...lottieData,
        direction: lottieData.direction * -1,
      });
    } else
      setLottieData({
        ...lottieData,
        isStopped: false,
        isLike: !lottieData.isLike,
      });
  }

  return (
    <React.Fragment onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
      <OpenCloseButton
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
        onClick={() => handleDrawerOpen()}
      >
        <MenuLottie
          onMouseEnter={mouseEnter}
          onMouseLeave={mouseLeave}
          options={defaultOptions}
          width={50}
          isStopped={lottieData.isStopped}
          isPaused={lottieData.isPaused}
          speed={lottieData.speed}
          direction={lottieData.direction}
          style={{
            margin: "0",
          }}
        />
      </OpenCloseButton>
      <NavDrawer
        mouseEnter={mouseEnter}
        mouseLeave={mouseLeave}
        isOpen={isDrawerOpen}
        onClick={() => handleDrawerOpen()}
      />
    </React.Fragment>
  );
}

function NavDrawer({ isOpen, mouseEnter, mouseLeave, ...delegated }) {
  return (
    <>
      <NavWrapper
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
        style={{
          "--drawer-offset": isOpen ? "0%" : "-100%",
        }}
      >
        <LeftColumn>
          <div>
            <Route>Home</Route>
            <Route>Services</Route>
            <Route>News</Route>
            <Route>Data collection</Route>
            <Route>About Us</Route>
          </div>
          <Row>
            <SubFooterText>Terms and Conditions</SubFooterText>
            <SubFooterText>By Elohim Studios</SubFooterText>
          </Row>
        </LeftColumn>
        <RightColumn>
          <InnerRightColumn>
            <GrowingBox>
              <BoxText>Request Stats</BoxText>
            </GrowingBox>
            <GrowingBox>
              <BoxText>Contact Us</BoxText>
            </GrowingBox>
          </InnerRightColumn>
        </RightColumn>
      </NavWrapper>
      <AnimatePresence>
        {isOpen && (
          <Overlay
            {...delegated}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.75 }}
          />
        )}
      </AnimatePresence>
    </>
  );
}

const Overlay = styled(motion.div)`
  position: fixed;
  z-index: 8;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: hsl(220deg 5% 40%/ 0.5);

  @media ${QUERIES.phoneAndSmaller} {
    display: none;
  }
`;

const NavWrapper = styled.div`
  position: fixed;
  z-index: 9;
  display: flex;
  gap: 20px;
  padding: 1.25rem 4rem;
  height: 100%;
  width: 70%;
  background-color: var(--color-primary);
  left: auto;
  right: var(--drawer-offset);
  top: 0;
  bottom: 0;
  transition: right 750ms cubic-bezier(0.27, 0.09, 0.21, 1);

  @media ${QUERIES.laptopAndSmaller} {
    width: 80%;
    transition: right 350ms cubic-bezier(0.27, 0.09, 0.21, 1);
  }
  @media ${QUERIES.phoneAndSmaller} {
    padding: 5.5rem 1.25rem 3rem;
    width: 100%;
    gap: 50px;
    flex-direction: column;
    transition: right 350ms cubic-bezier(0.27, 0.09, 0.21, 1);
  }
`;

const OpenCloseButton = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  width: 60px;
  height: 60px;
  margin: 20px;

  @media ${QUERIES.phoneAndSmaller} {
    height: initial;
    margin: 10px 10px;
  }
`;

const MenuLottie = styled(Lottie)``;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  flex: 3;

  @media ${QUERIES.phoneAndSmaller} {
    order: -1;
    flex: initial;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 4;
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 120px;

  @media ${QUERIES.phoneAndSmaller} {
    gap: 20px;
  }
`;

const Route = styled.h2`
  display: block;
  font-size: clamp(3.1875rem, 5.27778vw, 4.75rem);
  max-width: initial;
  color: var(--color-white);
  font-stretch: condensed;

  /* &:hover{
    color: var(--color-offwhite);
  } */
`;

const SubFooterText = styled.h5`
  color: var(--color-white);
  text-transform: uppercase;
  text-align: left;

  @media ${QUERIES.phoneAndSmaller} {
    font-size: 0.75rem;
  }
`;

const InnerRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;
  gap: 5px;
  flex: 1;
`;

const BoxText = styled.h2`
  font-size: 25px;
  font-stretch: condensed;
`;

const eleOneHoverGrow = keyframes`
  from {
    height: calc(10.3% - .1875rem);
    background-color: var(--color-white);
    color: var(--color-dark);
  }
  to{
    height: calc(25.3% - .1875rem);
    background-color: var(--color-dark-700);
    color: var(--color-white)
  }
`;
const eleOneHoverShrink = keyframes`
  from {
    height: calc(25.3% - .1875rem);
    background-color: var(--color-dark-700);
    color: var(--color-white)
  }
  to{
    height: calc(10.3% - .1875rem);
    background-color: var(--color-white);
    color: var(--color-primary);
  }
`;
const eleTwoHoverGrow = keyframes`
  from {
    height: calc(20.3% - .1875rem);
    width: calc(63.33% - 0.1875rem);
    background-color: var(--color-white);
    color: var(--color-dark-700);
  }
  to{
    height: calc(25.3% - .1875rem);
    width: calc(83.33% - 0.1875rem);
    background-color: var(--color-dark-700);
    color: var(--color-white)
  }
`;
const eleTwoHoverShrink = keyframes`
  from {
    height: calc(25.3% - .1875rem);
    width: calc(83.33% - 0.1875rem);
    background-color: var(--color-dark-700);
    color: var(--color-white)
  }
  to{
    height: calc(20.3% - .1875rem);
    width: calc(63.33% - 0.1875rem);
    background-color: var(--color-white);
    color: var(--color-primary);
  }
`;

const GrowingBox = styled(motion.div)`
  background-color: var(--color-white);
  color: var(--color-primary);
  width: calc(83.33% - 0.1875rem);
  height: calc(20.3% - 0.1875rem);
  padding: 10px;
  animation: ${eleOneHoverShrink} 350ms ease both;
  grid-column: 1 / -1;
  grid-row: 2;

  transition: all 350ms both alternate;
  &:hover {
    animation: ${eleOneHoverGrow} 350ms ease both;
  }

  ${RightColumn} &:nth-child(1) {
    width: calc(63.33% - 0.1875rem);
    grid-row: 2;
    animation: ${eleTwoHoverShrink} 350ms ease both;

    &:hover {
      animation: ${eleTwoHoverGrow} 350ms ease both;
    }
  }

  @media ${QUERIES.phoneAndSmaller} {
    animation: none;

    ${RightColumn} &:nth-child(1n) {
      animation: none;
      width: 100%;
      height: 70px;
    }
  }
`;
